module.exports = __webpack_public_path__ + "static/media/riseokr_desc1.43952a10.png";